import { BiweeklyPeriod, PayoutFrequencyType, WeeklyAnchorStripe } from "@modules/box/boxPayoutFrequencyTypes"
import { PaymentMethodMode, PaymentMethodType } from "@modules/finances/types/financesType"
import { z } from "zod"

export const PaymentMethodPreferenceDtoSchema = z
  .object({
    type: z.enum(PaymentMethodType),
    mode: z.enum(PaymentMethodMode),
    enabled: z.boolean(),
  })
  .meta({ id: "PaymentMethodPreferenceDtoSchema" })

export const PayoutFrequencyDtoSchema = z
  .object({
    type: z.enum(PayoutFrequencyType),
    dayCalendar: z.number().min(1).max(31).optional(),
    weeklyAnchorStripe: z.enum(WeeklyAnchorStripe).optional(),
    biweeklyPeriod: z.enum(BiweeklyPeriod).optional(),
  })
  .meta({ id: "PayoutFrequencyDtoSchema" })

export type PayoutFrequencyDto = z.infer<typeof PayoutFrequencyDtoSchema>
